import { render, staticRenderFns } from "./InstituInfo.vue?vue&type=template&id=b36914d6&scoped=true&"
import script from "./InstituInfo.vue?vue&type=script&lang=js&"
export * from "./InstituInfo.vue?vue&type=script&lang=js&"
import style0 from "./InstituInfo.vue?vue&type=style&index=0&id=b36914d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36914d6",
  null
  
)

export default component.exports